<template>
  <div class="app">
    <DefaultHeader>
      <HeaderQuickSearch></HeaderQuickSearch>
      <Breadcrumb :list="list" />
    </DefaultHeader>
    <div class="app-body">
      <AppSidebar fixed>
        <SidebarHeader></SidebarHeader>
        <SidebarForm />
        <SidebarNav :nav-items="nav" />
        <SidebarFooter />
        <SidebarMinimizer />
      </AppSidebar>
      <main class="main">
        <div class="container-fluid">
          <transition name="fade" mode="out-in">
            <router-view />
          </transition>
        </div>
      </main>
      <AppAside fixed>
        <!--aside-->
        <DefaultAside />
      </AppAside>
    </div>
    <DefaultFooter> </DefaultFooter>
  </div>
</template>

<script>
import nav from '@/_nav';
import {
  Sidebar as AppSidebar,
  SidebarFooter,
  SidebarForm,
  SidebarHeader,
  SidebarMinimizer,
  SidebarNav,
  Aside as AppAside,
  Breadcrumb
} from '@coreui/vue';
import DefaultAside from './DefaultAside';
import DefaultHeaderDropdownAccnt from './DefaultHeaderDropdownAccnt';
import DefaultHeader from './DefaultHeader';
import DefaultFooter from './DefaultFooter';
import HeaderQuickSearch from './HeaderQuickSearch';

export default {
  name: 'DefaultContainer',
  components: {
    AppSidebar,
    AppAside,
    Breadcrumb,
    DefaultAside,
    // DefaultHeaderDropdownAccnt,
    SidebarForm,
    SidebarFooter,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer,
    DefaultFooter,
    DefaultHeader,
    HeaderQuickSearch
  },
  data() {
    return {
      nav: [],
    };
  },
  computed: {
    list() {
      return this.$route.matched.filter(
        route => route.name || route.meta.label
      );
    }
  },
  mounted() {
    if (this.$store.getters['account/hasUserRole']('superadmin')) {
      this.nav = nav.superadmin;
    } else if (this.$store.getters['account/hasUserRole']('admin')) {
      this.nav = nav.admin;
    } else if (this.$store.getters['account/hasUserRole']('end-user')) {
      this.nav = nav.endUser;
    } else {
      // otherwise if admin
      this.nav = [];
    }
    // window.onresize = event => {
    //   if ($('body').width() < 1420) {
    //     $('body').addClass('sidebar-minimized');
    //     this.togglePs(false);
    //   } else {
    //     $('body').removeClass('sidebar-minimized');
    //     this.togglePs(true);
    //   }
    // };
  },
  methods: {
    togglePs(toggle) {
      const sidebar = document.querySelector('.sidebar-nav section');
      if (sidebar) {
        // sidebar.classList.toggle('ps', toggle);
        // sidebar.classList.toggle('ps-container', toggle);
        // sidebar.classList.toggle('ps--active-y', toggle);
        if (toggle) {
          sidebar.classList.add('ps', 'ps-container', 'ps--active-y');
        } else {
          sidebar.classList.remove('ps', 'ps-container', 'ps--active-y');
        }
      }
    }
  }
};
</script>
